module.exports = __webpack_public_path__ + "img/twitter.c593d97c.svg";